export function AlertIcon({ size = 26 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2.1667 -2.1667 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M10.8333 0.270833C16.6668 0.270833 21.3958 4.99982 21.3958 10.8333C21.3958 16.6668 16.6668 21.3958 10.8333 21.3958C4.99984 21.3958 0.270833 16.6668 0.270833 10.8333C0.270833 4.99983 4.99984 0.270851 10.8333 0.270833ZM10.8228 14.5361C10.2244 14.5361 9.73942 15.0212 9.73942 15.6195C9.7397 16.2175 10.2246 16.7028 10.8228 16.7028H10.8333C11.4313 16.7027 11.9164 16.2174 11.9167 15.6195C11.9167 15.0212 11.4315 14.5363 10.8333 14.5361H10.8228ZM10.8333 5.00089C10.235 5.00089 9.75 5.48698 9.75 6.08528V12.0436C9.75028 12.6417 10.2352 13.1269 10.8333 13.1269C11.4315 13.1269 11.9164 12.6417 11.9167 12.0436V6.08528C11.9167 5.48698 11.4316 5.00089 10.8333 5.00089Z"
        fill="currentColor"
      />
    </svg>
  )
}
